import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Session } from '../models/session'
import { Poll } from '../models/poll-new';
import { PollQuestionModel } from '../models/poll-question';
import { PollOptionsModel } from '../models/poll-options';

@Injectable()
export class PollService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  addPollDetail(eventID: string, poll: Poll) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.Poll_URL).push(poll).key;
  }

  updatePollDetail(eventID: string, pollId: string, poll: Poll): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.Poll_URL + "/" + pollId).set(poll);
  }

  updatePollPosition(eventID, pollList, pollDeletedIdList) {
    /*if(pollDeletedIdList != null) {
      for(let id of pollDeletedIdList) {
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.Poll_URL+'/'+id).set(null);
      } for(let item of pollList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.Poll_URL+"/"+key).update({position:item.position});
     }
    } else {*/
    for (let item of pollList) {
      console.log(item.$key, item.position);
      let key = item.$key;
      this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.Poll_URL + "/" + key).update({ position: item.position });
    }
    //}

  }

  getPollList(id: string): AngularFireList<string> {

    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.Poll_URL);
    }
    return null;
  }

  getPollDetail(id: string, pollId: string): Observable<Poll> {
    if (pollId != null) {
      let data: AngularFireObject<Poll> = this.db.object(Constants.EVENT_URL + '/' + id + Constants.Poll_URL + "/" + pollId);
      return data.valueChanges();
    }
  }

  deletePollID(event: Poll, eventId: string, pollList) {
    if (pollList.length <= 0) {
      return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.Poll_URL + "/").remove(event.$key);
    } else {
      for (let item of pollList) {
        this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.Poll_URL + "/").remove(event.$key);
        console.log(item.$key, item.position);
        let key = item.$key;
        return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Poll_URL + "/" + key).update({ position: item.position });
      }
    }

  }


  // start poll changes

  addPollQuestion(eventID: string, pollQuestion: PollQuestionModel) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.Poll_QUESTION_URL).push(pollQuestion).key;
  }

  updatePollQuestion(eventID: string, pollQuestionId: string, poll: PollQuestionModel): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.Poll_QUESTION_URL + "/" + pollQuestionId).set(poll);
  }

  getPollQuestion(id: string, pollQuestionId: string): Observable<PollQuestionModel> {
    if (pollQuestionId != null) {
      let data: AngularFireObject<PollQuestionModel> = this.db.object(Constants.EVENT_URL + '/' + id + Constants.Poll_QUESTION_URL + "/" + pollQuestionId);
      return data.valueChanges();
    }
  }

  getPollQuestionList(id: string): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.Poll_QUESTION_URL);
    }
    return null;
  }

  deletePollQuestionID(questionId, eventId: string) {
    return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.Poll_QUESTION_URL + "/").remove(questionId);
  }

  addPollOptions(eventID: string, pollOptions) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.Poll_OPTIONS_URL).push(pollOptions).key;
  }

  updatePollOptions(eventID: string, pollOptionId, pollOptions): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.Poll_OPTIONS_URL + "/" + pollOptionId).set(pollOptions);
  }

  getPollOptions(id: string, optionID: string): Observable<PollOptionsModel> {
    if (optionID != null) {
      let data: AngularFireObject<PollOptionsModel> = this.db.object(Constants.EVENT_URL + '/' + id + Constants.Poll_OPTIONS_URL + "/" + optionID);
      return data.valueChanges();
    }
  }

  getPollObj(id: string) {

    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.Poll_URL);
    }
    return null;
  }
  getSinglePollDetail(id: string, pollId: string) {
    if (pollId != null) {
      return this.db.object(Constants.EVENT_URL + '/' + id + Constants.Poll_URL + "/" + pollId);
    }
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/poll.service.ts